import { BaseNode } from '@abp/ng.components/tree';
import { PagedResultDto } from '@abp/ng.core';
import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { CostCentreTreeNode } from '@/cost-centre/models/cost-centre-tree-node.model';
import { StaffDto } from '@proxy/servicing-service/staffs';
import { LocationDto } from '@proxy/register-service/locations';
import {
  IdentityRoleDto,
  IdentityUserDto,
  OrganizationUnitWithDetailsDto,
} from '@volo/abp.ng.identity/proxy';

type UserOrganizationState = {
  response: PagedResultDto<OrganizationUnitWithDetailsDto>;
  nodes: BaseNode[];
  checkedKeys: string[];
  expandedKeys: string[];
  selectFn: () => boolean;
};

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.scss'],
})
export class UserModalComponent {
  @Input() busy = false;
  @Input() costCentres: PagedResultDto<CostCentreTreeNode> = { items: [], totalCount: 0 };
  @Input() checkedKeys: string[] = [];
  @Input() form: FormGroup | null = null;
  @Input() isCostCentre = false;
  @Input() isManager = false;
  @Input() notificationOptions: string[] = [];
  @Input() notificationSettings: Record<string, boolean> = {};
  @Input() organization!: UserOrganizationState;
  @Input() restrictedEvents: string[] = [];
  @Input() restrictedKeys: string[] = [];
  @Input() roles: Array<IdentityRoleDto & { name: string }> = [];
  @Input() roleGroups: FormGroup[] = [];
  @Input() selected = {} as IdentityUserDto;
  @Input() selectedLocation: LocationDto | null = null;
  @Input() selectedRole = '';
  @Input() staffUser?: StaffDto;
  @Input() trackByFn: TrackByFunction<AbstractControl> = index => index;
  @Input() title = '';
  @Input() visible = false;
  @Input() avatarUrl = '';
  @Input() modalBusy = false;
  @Input() capitalizeFirstLetter: (text: string) => string = text => text;

  @Output() checkedKeysChange = new EventEmitter<string[]>();
  @Output() disappear = new EventEmitter<void>();
  @Output() isCostCentreChange = new EventEmitter<boolean>();
  @Output() restrictedEventsChange = new EventEmitter<string[]>();
  @Output() restrictedKeysChange = new EventEmitter<string[]>();
  @Output() roleSelected = new EventEmitter<{ event: Event; name: string }>();
  @Output() saveClicked = new EventEmitter<void>();
  @Output() selectedLocationChange = new EventEmitter<LocationDto | null>();
  @Output() visibleChange = new EventEmitter<boolean>();

  onVisibleChange(value: boolean) {
    this.visible = value;
    this.visibleChange.emit(value);
  }

  onCheckedKeysChange(value: string[]) {
    this.checkedKeys = value;
    this.checkedKeysChange.emit(value);
  }

  onIsCostCentreChange(value: boolean) {
    this.isCostCentre = value;
    this.isCostCentreChange.emit(value);
  }

  onRestrictedEventsChange(value: string[]) {
    this.restrictedEvents = value;
    this.restrictedEventsChange.emit(value);
  }

  onRestrictedKeysChange(value: string[]) {
    this.restrictedKeys = value;
    this.restrictedKeysChange.emit(value);
  }

  onRoleSelected(event: Event, name: string) {
    this.roleSelected.emit({ event, name });
  }

  onSaveClicked() {
    this.saveClicked.emit();
  }

  onSelectedLocationChange(value: LocationDto | null) {
    this.selectedLocation = value;
    this.selectedLocationChange.emit(value);
  }
}
